// Determine if an element is in the visible viewport
export default function inViewport(element: any, container: any = document.documentElement) {
    const rect = element.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || container.clientHeight) &&
        rect.right <= (window.innerWidth || container.clientWidth)
    );
}



// WEBPACK FOOTER //
// ./utilities/inViewport.ts